import { SERVER_URL } from "./config";

const groupNames = ["group-1", "group-2", "group-3"];
function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}

const groupInfo = {
    "group-1": [
        {
            label: "Total Amount",
            className: "form-row",
            labelClassName: "form-label",
            inputClassName: "form-input",
            name: "total_amount",
            type: "text",
            placeHolder: "",
            url: SERVER_URL + "/city/",
            suggestionKeyword: "name",
            backendOnClickName: "station_from",
            suggestionBackendResponseMap: {
                id: "station_from",
            },
            toValidate: false,
            keyboardNavigationMap: {
                Enter: "add",
            },
        },
        {
            label: "Add(+)",
            className: "form-row",
            labelClassName: "form-label",
            inputClassName: "form-input",
            name: "add",
            type: "text",
            placeHolder: "",
            url: SERVER_URL + "/city/",
            suggestionKeyword: "name",
            backendOnClickName: "station_from",
            toValidate: false,
            keyboardNavigationMap: {
                Enter: "save_button",
            },
        },
        {
            label: "Grand Total",
            className: "form-row",
            labelClassName: "form-label",
            inputClassName: "form-input",
            name: "net_amount",
            type: "text",
            placeHolder: "",
            url: SERVER_URL + "/city/",
            suggestionKeyword: "name",
            backendOnClickName: "station_from",
            toValidate: false,
            keyboardNavigationMap: {
                Enter: "save_button",
            },
        },
    ],
    "group-2": [
        {
            label: "Consignor GST",
            className: "form-row",
            labelClassName: "form-label",
            inputClassName: "form-input",
            name: "consignor_gst",
            type: "text",
            placeHolder: "",
            apiConfigKey: "getConsignorSuggestions",
            url: SERVER_URL + "/consignor/",
            suggestionKeyword: "consignor_gst",
            suggestionKeywordForFetchApiArgs: "gst",
            suggestionChooseQueryKeyword: "consignor_id",
            suggestionSchema: {
                consignor_name: "consignor_name",
                consignor_gst: "consignor_gst",
                consignor_id: "consignor_id",
            },
            apiCallRequiredOnGetValue: true,
            toValidate: false,
            regExpValidation:
                "^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$",
            keyboardNavigationMap: {
                Enter: "consignee_name",
            },
            idClearanceNeeded: "consignor_id",
        },
        {
            label: "Extra(%)",
            className: "form-row",
            labelClassName: "form-label",
            inputClassName: "form-input-small",
            name: "extra_percentage",
            type: "text",
            placeHolder: "",
            url: SERVER_URL + "/city/",
            suggestionKeyword: "name",
            backendOnClickName: "station_from",
            suggestionBackendResponseMap: {
                id: "station_from",
            },
            toValidate: false,
            keyboardNavigationMap: {
                Enter: "add",
            },
        },
        {
            label: "Extra Hamali",
            className: "form-row",
            labelClassName: "form-label",
            inputClassName: "form-input-small",
            name: "extra_hamali",
            type: "text",
            placeHolder: "",
            url: SERVER_URL + "/city/",
            suggestionKeyword: "name",
            backendOnClickName: "station_from",
            toValidate: false,
            keyboardNavigationMap: {
                Enter: "save_button",
            },
        },
        {
            label: "DD Charge",
            className: "form-row",
            labelClassName: "form-label",
            inputClassName: "form-input",
            name: "door_del_charge",
            type: "text",
            placeHolder: "",
            url: SERVER_URL + "/city/",
            suggestionKeyword: "name",
            backendOnClickName: "station_from",
            toValidate: false,
            keyboardNavigationMap: {
                Enter: "save_button",
            },
        },
        {
            label: "Bilty Charge",
            className: "form-row",
            labelClassName: "form-label",
            inputClassName: "form-input",
            name: "bilty_charge",
            type: "text",
            placeHolder: "",
            url: SERVER_URL + "/city/",
            suggestionKeyword: "name",
            backendOnClickName: "station_from",
            toValidate: false,
            keyboardNavigationMap: {
                Enter: "save_button",
            },
        },
    ],
};

const transporterFieldInfo = {
    label: "Consignor Name",
    className: "form-row",
    labelClassName: "form-label",
    inputClassName: "form-input",
    name: "consignor_name",
    type: "text",
    placeHolder: "",
    apiConfigKey: "getConsignorSuggestions",
    url: SERVER_URL + "/consignor/",
    suggestionKeyword: "consignor_name",
    suggestionKeywordExtra: "consignor_gst",
    suggestionKeywordForFetchApiArgs: "name",
    suggestionChooseQueryKeyword: "consignor_id",
    suggestionSchema: {
        consignor_name: "consignor_name",
        consignor_gst: "consignor_gst",
        consignor_id: "consignor_id",
    },
    apiCallRequiredOnGetValue: true,
    toValidate: true,
    regExpValidation: "[a-zA-z]",
    keyboardNavigationMap: {
        Enter: "remarks",
    },
    idClearanceNeeded: "consignor_id",
    inputDataNeededInSuggestions: false,
    inputDataFilter: {
        pay_type: "same",
    },
};

const dataObject = {
    bill_no: "",
    amount: "",
    consignor_name: "",
    consignor_id: "",
    consignor_gst: "",
    input_date: formatDate(new Date()),
    bill_date: formatDate(new Date()),
    last_delivery_bill_no: "",
    remarks: "",
    description1: "",
    description2: "",
    amt1: "",
    amt2: "",
    mr_ids: [],
    gross_amount: "",
    extra_percentage: "",
    extra_percentage_amount: "",
    update_date_from: formatDate(new Date()),
    update_date_to: formatDate(new Date()),
    
    
    id: "",
    extra_hamali: "",
    door_del_charge: "",
    bilty_charge: "",
    total_amount: "",
    id: "",
    add: "0",               // to set the default value of add as 0
    net_amount: "",
    created_from: "",
    created_by: "",
    consignor_bill_no: "",
    edit_bill: "",
};

const mrBillingTableHeader = [
    { label: "S. No.", className: "text-center table-header" },
    { label: "Dr No", className: "text-center table-header" },
    { label: "Lr No", className: "text-center table-header" },
    { label: "Dr Date", className: "text-center table-header" },
    { label: "Station From", className: "text-center table-header" },
    { label: "Consignor", className: "text-center table-header" },
    { label: "Pkgs", className: "text-center table-header" },
    { label: "Total", className: "text-center table-header" },
];

const mrBillingTableItems = [
    {
        type: "text",
        name: "mr_no",
        label: "Dr No",
        className: "form-control-large-col",
    },
    {
        type: "text",
        name: "bilty_no",
        label: "Lr No",
        className: "form-control-large-col",
    },
    {
        type: "text",
        name: "mr_date",
        label: "Dr Date",
        className: "form-control-large-col",
    },
    {
        type: "text",
        name: "station_from_name",
        label: "Station From",
        className: "form-control-large-col",
    },
    {
        type: "text",
        name: "consignor_name",
        label: "Consignor",
        className: "form-control-large-col",
    },
    {
        type: "text",
        name: "pkgs",
        label: "Pkgs",
        className: "form-control-medlargemed-col",
    },
    {
        type: "text",
        name: "total_amount",
        label: "Total",
        className: "form-control-large-col",
    },
];

function validate(values) {
    let errors = {};

    //   function validator(value, regexp) {
    //     var regex = new RegExp(regexp);
    //     if (values.hasOwnProperty(value)) {
    //       if (!values[value].trim()) {
    //         errors[value] = "Required Field";
    //       } else if (!regex.test(values[value])) {
    //         errors[value] = "Validation Error";
    //       } else {
    //         errors[value] = "";
    //       }
    //     }
    //   }
    //   for (let group_name of groupNames) {
    //     for (let i = 0; i < groupInfo[group_name].length; i++) {
    //       console.log(groupInfo[group_name][i]);
    //       let field_object = groupInfo[group_name][i];
    //       if (field_object.toValidate) {
    //         validator(field_object.name, field_object.regExpValidation);
    //       }
    //     }
    //   }
    return errors;
}

const popupInfo = {
    success_header: "Delivery Bill Saving Successful ",
    error_header: "Error In Delivery Bill Module ",
    success_title: "Delivery Bill is successfully created with the following info:-",
    field_label_success: "Delivery Bill",
    field_name_success: "id",
    error_title: "Error in Delivery Bill module with the following info:-",
    field_label_error: "Error:",
};

export { transporterFieldInfo, groupInfo, groupNames, dataObject, validate, popupInfo, mrBillingTableItems, mrBillingTableHeader };